import React from 'react'
import ReactDOM from "react-dom";
import toastr from "toastr";

class SocialShare extends React.Component {
    constructor() {
        super();

        this.state = {
            urlToShare: "",
            message: "",
            shareTitle: "",
            shareAchievement: ""
        };

        this.createEvent();

        this.copyText = this.copyText.bind(this);
        this.shareAchievement = this.shareAchievement.bind(this);
    }

    createEvent() {
        document.querySelectorAll('[data-bs-target="#social-share-modal"]').forEach(socialShare => {
            socialShare.addEventListener("click", e => {
                e.preventDefault();

                //Get Url to share from button
                this.setState({
                    urlToShare: e.delegateTarget.dataset.url,
                    message: e.delegateTarget.dataset.message || e.delegateTarget.dataset.url,
                    shareTitle: e.delegateTarget.dataset.sharetitle,
                    shareAchievement: e.delegateTarget.dataset.shareachievement || ""
                });
            })
        });
    }

    copyText(event) {
        const text = event.target.previousElementSibling.value;

        navigator.clipboard.writeText(text).then(() => {
            toastr.options = {
                "closeButton": false,
                "debug": false,
                "newestOnTop": false,
                "progressBar": false,
                "positionClass": "toast-top-right",
                "preventDuplicates": true,
                "onClick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            }

            toastr["success"](window.shareLabels.message || "Text copied");
        });

        this.shareAchievement();
    }

    shareAchievement() {
        if(this.state.shareAchievement) {
            fetch('/achievements/store-share?type=' + this.state.shareAchievement)
                .then((response) => console.log(response));
        }
    }


    render() {
        const urlToShare = this.state.urlToShare;
        const message = this.state.message;
        const shareTitle = this.state.shareTitle;

        return (
            <div className="social-share-modal modal fade" id="social-share-modal" tabIndex="-1" aria-labelledby="social-share-modal"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="shareModalLabel">{shareTitle}</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <ul className={"d-flex flex-wrap justify-between p-0"}>
                                <li>
                                    <a href={"https://api.whatsapp.com/send?text=" + message} className="wa"
                                       type="button" target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-whatsapp"></i>
                                    </a>
                                </li>
                                {/* Not supported
                                <li>
                                    <a href={"https://t.me/share/url?url=" + message} className="ig" type="button"
                                       target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-instagram"></i>
                                    </a>
                                </li>
                                */}
                                <li>
                                    <a href={"https://t.me/share/url?url=" + message} className="tg" type="button"
                                       target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-telegram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://www.snapchat.com/share?link=" + message} className="sc" type="button"
                                       target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-snapchat"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={"fb-messenger://share/?link=" + message} className="msg" type="button"
                                       target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-messenger"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://www.facebook.com/sharer.php?u=" + message} className="fb"
                                       type="button" target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://twitter.com/share?url=" + message} className="x" type="button"
                                       target="_blank" onClick={this.shareAchievement}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                            <path
                                                d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                        </svg>
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://reddit.com/submit?url=" + message} className="rdt"
                                       type="button" target="_blank" onClick={this.shareAchievement}>
                                    <i className="bi bi-reddit"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://pinterest.com/pin/create/bookmarklet/?url=" + message}
                                       className="pi" type="button" target="_blank" onClick={this.shareAchievement}>
                                        <i className="bi bi-pinterest"></i>
                                    </a>
                                </li>
                            </ul>

                            <div className="input-group mb-3 mt-3">
                                <input type="text" className="form-control" id={"share-link-input"} value={urlToShare} readOnly aria-label="Share the link" aria-describedby="share-link"/>
                                <button className="btn btn-primary" type="button" id="share-link" onClick={this.copyText}>
                                    {window.shareLabels.copy}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SocialShare;

if (document.getElementById('social-share-modal-container')) {
    ReactDOM.render(<SocialShare/>, document.getElementById('social-share-modal-container'));
}
